import { get, pipe } from "lodash/fp";

const getPageImage = pipe(
  get("heroImage.fluid.src"),
  url => (!/^https?:\/\//i.test(url) ? `https:${url}` : url),
  url => url.split("?")[0]
);

export default getPageImage;
